export default __webpack_public_path__ + "assets/img_motorhome_xl-51228e46.png";